export default "__VITE_ASSET__CI9Pgt2b__"